/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: Causals
// ====================================================

export interface Causals_causals {
  __typename: "Causal";
  id: string;
  causal: string;
}

export interface Causals {
  causals: Causals_causals[];
}
